import type { ReactNode } from 'react';

import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const level2Css = css({
	margin: 0,
	textAlign: 'center',
});

const level3Css = css({
	margin: 0,
	fontFamily: 'var(--atlassian-sans-font-family)',
	fontSize: '1.25rem',
	lineHeight: '1.5rem',
	fontWeight: 700,
	color: token('color.text'),
	textAlign: 'center',
});

// Smaller variant of level 3, used in-row alongside icons (e.g. the
// use-case buttons) where the default 1.25rem is too tall.
const level3SmallCss = css({
	fontSize: '1.15em',
});

export type LoomOnboardingHeadingProps = {
	children: ReactNode;
	level: 2 | 3;
	/**
	 * Optional size modifier. Currently only affects `level={3}`:
	 * - `md` (default) → 1.25rem, matches the shared design.
	 * - `sm`           → 1.15em, used inline with 32px icon tiles.
	 */
	size?: 'sm' | 'md';
};

/**
 * Reusable heading for the Loom onboarding flow.
 * - levels are equal to the 'h' html tags
 */
export const LoomOnboardingHeading = ({
	children,
	level,
	size = 'md',
}: LoomOnboardingHeadingProps) => {
	if (level === 2) {
		return <h2 css={level2Css}>{children}</h2>;
	}

	return (
		<div role="heading" aria-level={3} css={[level3Css, size === 'sm' && level3SmallCss]}>
			{children}
		</div>
	);
};
